import { Component, Input, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Component({
    selector: 'pv-level-of-experience-render',
    template: `
    <span [style.color]="color" style="font-weight: 700;">
        {{renderValue}}
    </span>
  `,
    standalone: false
})
export class LevelOfExperienceRenderComponent implements OnInit {

  renderValue: string;
  color: string;

  @Input() value: string | number;
  @Input() rowData: any;

  constructor(private translateService: TranslateService) {}

  ngOnInit() {
    this.renderValue = this.switch();
  }

  switch() : string {
    let numericValue = Number(this.value);
    if (numericValue < .5) {
      this.color = '#eb5757';
      return this.translateService.instant('valet.page.evaluation.levelOfExperience.beginner');
    }
    if (numericValue < 1){
      this.color = '#f2994a';

      return this.translateService.instant('valet.page.evaluation.levelOfExperience.middle');
    }
    this.color = '#78d29d';
    return this.translateService.instant('valet.page.evaluation.levelOfExperience.expert');
  }

}
